import { render, staticRenderFns } from "./CompeteContentProblem.vue?vue&type=template&id=16c082c4&"
import script from "./CompeteContentProblem.vue?vue&type=script&lang=js&"
export * from "./CompeteContentProblem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports